import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import {
  useHeaderBackNavigate,
  useHeaderTitle,
} from "@Light/components/page/header/context";
import { useScaffold } from "@Light/scaffold";
import React from "react";

const BACK_ROUTE = "/account/details/";

export type UpdateEmailProps = {};

export const UpdateEmail: React.FC<UpdateEmailProps> = ({}) => {
  const scaffold = useScaffold();

  useHeaderTitle("Update your email");
  useHeaderBackNavigate(BACK_ROUTE);

  const PageBody = scaffold.page.pageBody;
  const Link = scaffold.system.link;
  const Hyperlink = scaffold.page.hyperlink;
  return (
    <PageBody
      subtitle={
        <>
          To update your email address, please contact us at{" "}
          <Hyperlink href={`mailto:${scaffold.page.supportEmail}`}>
            {scaffold.page.supportEmail}
          </Hyperlink>
        </>
      }
      footer={
        <ButtonFooter>
          <Link to={BACK_ROUTE}>
            <Button size="lg" className="w-full">
              Return
            </Button>
          </Link>
        </ButtonFooter>
      }
    />
  );
};
